import { Component } from '@theme/component';

class FeaturedProductsPanel extends Component {
  requiredRefs = ['products', 'next', 'back'];

  #isScrolling = false;
  #slide = 1;
  #visibilityThreshold = 2;

  get slideCount() {
    return this.refs.products.children.length;
  }

  connectedCallback() {
    super.connectedCallback();
    this.#setSlideNumbers();
    this.#listenForScroll();
    this.#setButtonVisibility();
  }

  scrollToNext() {
    this.#setActiveSlide(this.#slide + 1);
  }

  scrollToPrevious() {
    this.#setActiveSlide(this.#slide - 1);
  }

  #setSlideNumbers() {
    [...this.refs.products.children].map((slide, index) => {
      slide.dataset.slideNumber = (index + 1).toString()
    })
  }

  #setActiveSlide(newSlide) {
    if (newSlide > 0 && newSlide <= this.slideCount) {
      const slide = this.refs.products.querySelector(`[data-slide-number="${newSlide}"]`);
      slide.scrollIntoView({ behavior: 'smooth' });
      this.#slide = newSlide;

      this.#setButtonVisibility();
    }
  }

  #listenForScroll() {
    this.refs.products.addEventListener('scroll', () => {
      if (this.#isScrolling) {
        return;
      }

      this.#isScrolling = true;

      requestAnimationFrame(() => {
        [...this.refs.products.children].forEach((slide) => {
          if (this.#isSlideVisible(slide)) {
            this.#slide = Number(slide.dataset.slideNumber);
            this.#setButtonVisibility();
          }
        });

        this.#isScrolling = false;;
      })
    });
  }

  #isSlideVisible(slide) {
    const rect = slide.getBoundingClientRect();
    const containerRect = this.refs.products.getBoundingClientRect();

    return (
      Math.abs(rect.top - containerRect.top) <= this.#visibilityThreshold &&
      Math.abs(rect.left - containerRect.left) <= this.#visibilityThreshold &&
      Math.abs(rect.bottom - containerRect.bottom) <= this.#visibilityThreshold &&
      Math.abs(rect.right - containerRect.right) <= this.#visibilityThreshold
    );
  }

  #setButtonVisibility() {
    this.refs.next.classList.toggle('hidden', this.#slide === this.slideCount);
    this.refs.back.classList.toggle('hidden', this.#slide === 1);
  }
}

if (!customElements.get('featured-products-panel')) {
  customElements.define('featured-products-panel', FeaturedProductsPanel);
}